import { render } from "./tempLandingPage.vue?vue&type=template&id=4519a7e0"
import script from "./tempLandingPage.vue?vue&type=script&lang=js"
export * from "./tempLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__